export default __webpack_public_path__ + "static/media/SEA_8366.80666d08.jpg";